import React from 'react';
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';

/**
 * Pioneer Checkbox — wraps MUI Checkbox with project defaults.
 *
 * Defaults:
 * - size="small" (Pioneer standard)
 * - color="primary" (Pioneer standard)
 *
 * All MUI Checkbox props are supported and can override defaults.
 */
export interface CheckboxProps extends MuiCheckboxProps {}

const Checkbox = React.forwardRef<React.ComponentRef<typeof MuiCheckbox>, CheckboxProps>(
  function Checkbox(props, ref) {
    return <MuiCheckbox size="small" color="primary" ref={ref} {...props} />;
  },
);

export default Checkbox;
